// extracted by mini-css-extract-plugin
export default {"container":"ScrollDown_container__EojFb","arrowDown":"ScrollDown_arrowDown__XqgbN"};